(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["press-carousel"] && !Shopify.designMode) return;
  try {
    
/*
 * Press carousel strip
 * ---------------------------------------------------------------
 * - Finds the site's background color (or uses the custom one set in the
 *   theme editor) and derives the logo color from it (default 45% darker).
 * - Turns every uploaded logo into a single-color logo on a transparent
 *   background: it detects the logo's background (white box, colored box,
 *   or an already-transparent PNG), turns that into transparency, then
 *   recolors the logo with the logo color.
 * - Trims empty space around each logo and sizes logos so wide wordmarks
 *   and square marks look balanced on the strip.
 * - Scrolls the logos in a seamless loop, pausing on hover/focus, when the
 *   strip is off screen, and not at all for "reduce motion" users.
 */
(() => {
  'use strict';

  if (window.PressCarousel) {
    window.PressCarousel.initAll();
    return;
  }

  /* ---------- color helpers ---------- */

  const probe = document.createElement('canvas');
  probe.width = probe.height = 1;
  const probeCtx = probe.getContext('2d', { willReadFrequently: true });

  // Normalizes any CSS color string (hex, rgb(), hsl(), color(), names…) to {r,g,b,a}.
  function parseColor(css) {
    if (!css) return null;
    probeCtx.clearRect(0, 0, 1, 1);
    probeCtx.fillStyle = 'rgba(0,0,0,0)';
    probeCtx.fillStyle = css;
    probeCtx.fillRect(0, 0, 1, 1);
    const [r, g, b, a] = probeCtx.getImageData(0, 0, 1, 1).data;
    return { r, g, b, a: a / 255 };
  }

  // Walks up from the strip until it finds an element with a solid background.
  function findSiteBackground(el) {
    for (let node = el; node && node.nodeType === 1; node = node.parentElement) {
      const c = parseColor(getComputedStyle(node).backgroundColor);
      if (c && c.a > 0.5) return c;
    }
    return { r: 255, g: 255, b: 255, a: 1 };
  }

  // "X% darker": a true shade of the background (mixed with X% black), so it
  // keeps the background's exact hue/tint — e.g. white → #8c8c8c at 45%.
  function darken({ r, g, b }, amount) {
    const k = 1 - amount;
    return { r: Math.round(r * k), g: Math.round(g * k), b: Math.round(b * k) };
  }

  const toCss = ({ r, g, b }) => `rgb(${r}, ${g}, ${b})`;

  /* ---------- logo processing ---------- */

  const MAX_SOURCE = 700; // px — processing resolution (logos are displayed far smaller)
  const NOISE = 20; // color distance treated as background noise (JPEG artifacts, paper texture)
  const cache = new Map();

  function median(values) {
    if (!values.length) return 255;
    values.sort((a, b) => a - b);
    return values[values.length >> 1];
  }

  function waitForImage(img) {
    if (img.complete && img.naturalWidth) return Promise.resolve();
    return new Promise((resolve, reject) => {
      img.addEventListener('load', resolve, { once: true });
      img.addEventListener('error', reject, { once: true });
    });
  }

  // Returns { url, ratio } for a transparent, single-color, trimmed version of the logo.
  async function extractLogo(img, color) {
    const nw = img.naturalWidth;
    const nh = img.naturalHeight;
    const scale = Math.min(1, MAX_SOURCE / Math.max(nw, nh));
    const w = Math.max(1, Math.round(nw * scale));
    const h = Math.max(1, Math.round(nh * scale));

    const canvas = document.createElement('canvas');
    canvas.width = w;
    canvas.height = h;
    const ctx = canvas.getContext('2d', { willReadFrequently: true });
    ctx.drawImage(img, 0, 0, w, h);
    const src = ctx.getImageData(0, 0, w, h).data; // throws if the image is cross-origin without CORS

    const n = w * h;
    const alpha = new Float32Array(n);

    // 1. Look at the outer edge of the image to learn what its "background" is.
    const border = [];
    for (let x = 0; x < w; x++) border.push(x, (h - 1) * w + x);
    for (let y = 1; y < h - 1; y++) border.push(y * w, y * w + w - 1);

    let clearEdge = 0;
    for (const p of border) if (src[p * 4 + 3] < 128) clearEdge++;
    const alreadyTransparent = clearEdge / border.length > 0.4;

    if (alreadyTransparent) {
      // PNG/SVG with a transparent background: keep its shape as-is.
      for (let p = 0; p < n; p++) alpha[p] = src[p * 4 + 3] / 255;
    } else {
      // Solid background (white box, colored box, photo of paper…): estimate its color.
      const rs = [];
      const gs = [];
      const bs = [];
      for (const p of border) {
        const i = p * 4;
        if (src[i + 3] >= 128) {
          rs.push(src[i]);
          gs.push(src[i + 1]);
          bs.push(src[i + 2]);
        }
      }
      const bgR = median(rs);
      const bgG = median(gs);
      const bgB = median(bs);

      // 2. Every pixel's opacity = how different it is from that background.
      const dist = new Float32Array(n);
      const hist = new Uint32Array(443);
      let ink = 0;
      for (let p = 0; p < n; p++) {
        const i = p * 4;
        const dr = src[i] - bgR;
        const dg = src[i + 1] - bgG;
        const db = src[i + 2] - bgB;
        const d = Math.sqrt(dr * dr + dg * dg + db * db);
        dist[p] = d;
        hist[d | 0]++;
        if (d > NOISE) ink++;
      }
      if (!ink) return null;

      // "Full ink" level adapts to the logo's own contrast, so a pale-gray or
      // pastel logo still comes out solid while anti-aliased edges stay smooth.
      let hi = NOISE + 1;
      for (let acc = 0, target = ink * 0.35; hi < 442; hi++) {
        acc += hist[hi];
        if (acc >= target) break;
      }
      hi = Math.max(hi, NOISE + 40);
      const lo = NOISE * 0.6;
      const span = hi - lo;

      for (let p = 0; p < n; p++) {
        const a = (dist[p] - lo) / span;
        alpha[p] = (a <= 0 ? 0 : a >= 1 ? 1 : a) * (src[p * 4 + 3] / 255);
      }
    }

    // 3. Trim the empty space around the logo so sizing is based on the mark itself.
    let x0 = w;
    let y0 = h;
    let x1 = -1;
    let y1 = -1;
    for (let y = 0; y < h; y++) {
      for (let x = 0; x < w; x++) {
        if (alpha[y * w + x] > 0.06) {
          if (x < x0) x0 = x;
          if (x > x1) x1 = x;
          if (y < y0) y0 = y;
          if (y > y1) y1 = y;
        }
      }
    }
    if (x1 < 0) return null;

    // 4. Paint the logo in the logo color using the computed transparency.
    const cw = x1 - x0 + 1;
    const ch = y1 - y0 + 1;
    const out = document.createElement('canvas');
    out.width = cw;
    out.height = ch;
    const octx = out.getContext('2d');
    const outData = octx.createImageData(cw, ch);
    const od = outData.data;
    for (let y = 0; y < ch; y++) {
      for (let x = 0; x < cw; x++) {
        const o = (y * cw + x) * 4;
        od[o] = color.r;
        od[o + 1] = color.g;
        od[o + 2] = color.b;
        od[o + 3] = Math.round(alpha[(y + y0) * w + (x + x0)] * 255);
      }
    }
    octx.putImageData(outData, 0, 0);

    const blob = await new Promise((resolve) => out.toBlob(resolve, 'image/png'));
    if (!blob) return null;
    return { url: URL.createObjectURL(blob), ratio: cw / ch };
  }

  // Optical sizing: equal visual weight for wide wordmarks and square marks.
  // Values are multiples of the "Logo size" setting.
  function sizeFor(ratio) {
    const MAX_W = 3.2;
    let w = Math.sqrt(ratio);
    let h = 1 / w;
    if (h > 1) {
      h = 1;
      w = ratio;
    }
    if (w > MAX_W) {
      w = MAX_W;
      h = MAX_W / ratio;
    }
    return { w, h };
  }

  function applySize(img, ratio) {
    const { w, h } = sizeFor(ratio);
    img.style.setProperty('--pc-w', w.toFixed(3));
    img.style.setProperty('--pc-h', h.toFixed(3));
  }

  async function processLogo(img, color) {
    const original = img.dataset.pcSrc || img.currentSrc || img.src;
    img.dataset.pcSrc = original;
    const key = `${original}|${color.r},${color.g},${color.b}`;
    try {
      if (img.crossOrigin == null && new URL(original, location.href).origin !== location.origin) {
        img.crossOrigin = 'anonymous';
        img.src = original;
      }
      await waitForImage(img);
      if (!cache.has(key)) cache.set(key, extractLogo(img, color));
      const result = await cache.get(key);
      if (!result) throw new Error('empty logo');
      img.removeAttribute('srcset');
      img.removeAttribute('sizes');
      img.src = result.url;
      applySize(img, result.ratio);
      img.classList.remove('is-fallback');
      img.classList.add('is-processed');
    } catch (err) {
      cache.delete(key);
      // Couldn't read the pixels (e.g. a cross-origin image): show the original
      // in a muted grayscale treatment instead.
      if (img.naturalWidth) applySize(img, img.naturalWidth / img.naturalHeight);
      img.classList.add('is-fallback');
    }
  }

  /* ---------- carousel ---------- */

  const instances = new Map();
  const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)');

  class PressCarousel {
    constructor(root) {
      this.root = root;
      this.viewport = root.querySelector('.press-carousel__viewport');
      this.track = root.querySelector('.press-carousel__track');
      this.group = root.querySelector('.press-carousel__group');
      this.pauses = new Set();
      this.lastWidth = 0;
      this.onResize = this.onResize.bind(this);
      this.onMotionChange = () => this.build();
    }

    async init() {
      const { root } = this;
      root.classList.add('js-ready');
      this.applyColors();

      const imgs = [...this.group.querySelectorAll('img[data-pc-logo]')];
      const allDone = Promise.all(imgs.map((img) => processLogo(img, this.color)));
      // Don't let one slow logo hold up the scrolling: start after 2.5s at most.
      await Promise.race([allDone, new Promise((r) => setTimeout(r, 2500))]);
      if (!this.root.isConnected) return;

      root.classList.add('is-loaded');
      this.build();
      allDone.then(() => this.root.isConnected && this.build());

      this.resizeObserver = new ResizeObserver(this.onResize);
      this.resizeObserver.observe(this.viewport);

      this.visibilityObserver = new IntersectionObserver(([entry]) => {
        this.setPaused('offscreen', !entry.isIntersecting);
      });
      this.visibilityObserver.observe(root);

      if (root.dataset.pauseOnHover === 'true') {
        this.viewport.addEventListener('pointerenter', (e) => {
          if (e.pointerType === 'mouse') this.setPaused('hover', true);
        });
        this.viewport.addEventListener('pointerleave', () => this.setPaused('hover', false));
      }
      // Keyboard focus only (a tap on a logo link shouldn't stop the strip).
      this.viewport.addEventListener('focusin', (e) => {
        if (e.target.matches(':focus-visible')) this.setPaused('focus', true);
      });
      this.viewport.addEventListener('focusout', () => this.setPaused('focus', false));
      reduceMotion.addEventListener?.('change', this.onMotionChange);
    }

    applyColors() {
      const { dataset } = this.root;
      const amount = Math.min(0.95, Math.max(0, Number(dataset.darken || 45) / 100));
      const custom = dataset.bgMode === 'custom';
      // The strip uses the site's own background (or the custom color);
      // logos are that background made darker.
      const bg = custom ? parseColor(dataset.bgColor) : findSiteBackground(this.root.parentElement);
      this.color =
        dataset.colorMode === 'custom' && dataset.logoColor
          ? parseColor(dataset.logoColor)
          : darken(bg, amount);
      if (custom) this.root.style.setProperty('--pc-bg', toCss(bg));
      this.root.style.setProperty('--pc-color', toCss(this.color));
    }

    build() {
      const progress =
        this.anim && this.duration ? (this.anim.currentTime % this.duration) / this.duration : 0;
      if (this.anim) this.anim.cancel();
      this.anim = null;
      this.track.querySelectorAll('[data-pc-clone]').forEach((el) => el.remove());

      const items = this.group.children.length;
      const respectReduced = this.root.dataset.respectReducedMotion === 'true';
      const isStatic = (respectReduced && reduceMotion.matches) || items === 0;
      this.root.classList.toggle('is-static', isStatic);
      if (isStatic) return;

      const groupWidth = this.group.getBoundingClientRect().width;
      const viewportWidth = this.viewport.clientWidth;
      this.lastWidth = viewportWidth;
      if (!groupWidth) return;

      // Enough copies that the strip is always full while it loops.
      const copies = Math.max(1, Math.ceil(viewportWidth / groupWidth));
      for (let i = 0; i < copies; i++) {
        const clone = this.group.cloneNode(true);
        clone.setAttribute('aria-hidden', 'true');
        clone.setAttribute('data-pc-clone', '');
        clone.removeAttribute('role');
        clone.querySelectorAll('a, button').forEach((el) => el.setAttribute('tabindex', '-1'));
        clone.querySelectorAll('[data-shopify-editor-block]').forEach((el) => el.removeAttribute('data-shopify-editor-block'));
        this.track.appendChild(clone);
      }

      const speed = Math.max(5, Number(this.root.dataset.speed) || 40); // px per second
      this.duration = (groupWidth / speed) * 1000;
      this.anim = this.track.animate(
        [{ transform: 'translate3d(0, 0, 0)' }, { transform: `translate3d(${-groupWidth}px, 0, 0)` }],
        {
          duration: this.duration,
          iterations: Infinity,
          easing: 'linear',
          direction: this.root.dataset.direction === 'right' ? 'reverse' : 'normal',
        }
      );
      this.anim.currentTime = progress * this.duration;
      if (this.pauses.size) this.anim.pause();
    }

    onResize() {
      const width = this.viewport.clientWidth;
      if (Math.abs(width - this.lastWidth) < 2) return;
      clearTimeout(this.resizeTimer);
      this.resizeTimer = setTimeout(() => this.build(), 150);
    }

    setPaused(reason, paused) {
      if (paused) this.pauses.add(reason);
      else this.pauses.delete(reason);
      if (!this.anim) return;
      if (this.pauses.size) this.anim.pause();
      else this.anim.play();
    }

    destroy() {
      this.resizeObserver?.disconnect();
      this.visibilityObserver?.disconnect();
      reduceMotion.removeEventListener?.('change', this.onMotionChange);
      clearTimeout(this.resizeTimer);
      this.anim?.cancel();
    }
  }

  function initAll(scope = document) {
    scope.querySelectorAll('[data-press-carousel]').forEach((root) => {
      if (instances.has(root)) return;
      const instance = new PressCarousel(root);
      instances.set(root, instance);
      instance.init();
    });
  }

  function destroyIn(scope) {
    for (const [root, instance] of instances) {
      if (scope.contains(root)) {
        instance.destroy();
        instances.delete(root);
      }
    }
  }

  window.PressCarousel = { initAll, instances };

  // Theme editor support: re-run when the section is added, edited or removed.
  document.addEventListener('shopify:section:load', (e) => initAll(e.target));
  document.addEventListener('shopify:section:unload', (e) => destroyIn(e.target));
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => initAll());
  } else {
    initAll();
  }
})();

  } catch(e) { console.error(e); }
})();
})();
